/**
 * projectColumns.js - the Projects table's columns, in their default order
 * (moved out of ProjectsView 10/9/26 so the Customize panel, the totals row
 * and the export all read the one list). Each person's saved view can hide
 * and reorder them (components/tableViews/); the Actions cell is not here -
 * it is always last and always shown.
 *
 *   kind        'number' | 'date' | 'text' - which highlight conditions apply
 *   minWidth    the <col> width (maxWidth too for Inv. #)
 *   exportLabel the CSV header, as the export has always named it
 *   noFilter    no funnel (Tasks / Comments have no value to filter)
 *   noExport    not in the CSV (Tasks / Comments are widgets, not values)
 *
 * server/routes/tableViews.js keeps the same ids (test_table_views.js
 * compares the two), so a saved view can only name real columns.
 */
export const PROJECT_COLUMNS = [
  { col: 'quoteDate', label: 'Quote Date', sortable: true, num: false, kind: 'date', minWidth: 56, exportLabel: 'Quote Date' },
  { col: 'customer', label: 'Customer', sortable: true, num: false, kind: 'text', minWidth: 90 },
  { col: 'subCustomer', label: 'Sub', sortable: false, num: false, kind: 'text', minWidth: 60, exportLabel: 'Sub Customer' },
  { col: 'description', label: 'Description', sortable: true, num: false, kind: 'text', minWidth: 200 },
  { col: 'tasks', label: 'Tasks', sortable: false, num: false, minWidth: 165, noFilter: true, noExport: true },
  { col: 'comments', label: 'Comments', sortable: false, num: false, minWidth: 165, noFilter: true, noExport: true },
  { col: 'approvalManager', label: 'Appr. Mgr', sortable: true, num: false, kind: 'text', minWidth: 80, exportLabel: 'Approval Manager' },
  { col: 'engineer', label: 'Engineer', sortable: true, num: false, kind: 'text', minWidth: 90 },
  { col: 'quoteLetter', label: 'Quote #', sortable: true, num: false, kind: 'text', minWidth: 60 },
  { col: 'rev', label: 'REV', sortable: true, num: false, kind: 'text', minWidth: 42, exportLabel: 'Rev' },
  { col: 'quotedPrice', label: 'Quoted', sortable: true, num: true, kind: 'number', minWidth: 80 },
  /* PO group - kept adjacent by default; Net terms (projects.terms) follows PO # */
  {
    col: 'poDateIssued',
    label: 'PO Date',
    sortable: true,
    num: false,
    kind: 'date',
    minWidth: 60,
    group: 'po',
    exportLabel: 'PO Date Issued',
  },
  { col: 'poNumber', label: 'PO #', sortable: false, num: false, kind: 'text', minWidth: 70, group: 'po' },
  { col: 'terms', label: 'Net terms', sortable: true, num: false, kind: 'text', minWidth: 64, group: 'po', exportLabel: 'Net Terms' },
  { col: 'poValue', label: 'PO $', sortable: true, num: true, kind: 'number', minWidth: 75, group: 'po', exportLabel: 'PO Value' },
  { col: 'globalProjectNumber', label: 'Global Project Number', sortable: false, num: false, kind: 'text', minWidth: 90 },
  /* computed financials */
  { col: 'cogs', label: 'COGS', sortable: false, num: true, kind: 'number', minWidth: 75 },
  { col: 'profit', label: 'Profit', sortable: false, num: true, kind: 'number', minWidth: 75 },
  { col: 'margin', label: 'Margin', sortable: false, num: true, kind: 'number', percent: true, minWidth: 50 },
  /* Invoice group */
  {
    col: 'latestInvoiceDate',
    label: 'Inv. Date',
    sortable: true,
    num: false,
    kind: 'date',
    minWidth: 60,
    group: 'inv',
    exportLabel: 'Invoice Date',
  },
  {
    col: 'invoiceNumbers',
    label: 'Inv. #',
    sortable: false,
    num: false,
    kind: 'text',
    minWidth: 62,
    maxWidth: 78,
    group: 'inv',
    exportLabel: 'Invoice #',
  },
  {
    col: 'invoicedAlready',
    label: 'Invoiced',
    sortable: true,
    num: true,
    kind: 'number',
    minWidth: 75,
    group: 'inv',
    exportLabel: 'Invoiced Already',
  },
  {
    col: 'moneyLeftover',
    label: 'Leftover',
    sortable: true,
    num: true,
    kind: 'number',
    minWidth: 80,
    group: 'inv',
    amber: true,
    exportLabel: '$ Left Over',
  },
  { col: 'status', label: 'Status', sortable: false, num: false, kind: 'text', minWidth: 55 },
];
